export default __webpack_public_path__ + "static/media/level-badge.07cd5ba2.svg";